export function scheduleVideoStart(element, seconds, start, environment = window) {
	const delay = Number(seconds);
	if (!Number.isFinite(delay) || delay <= 0) {
		return () => {};
	}

	let timer = null;
	let observer;
	let cancelled = false;
	const clearTimer = () => {
		if (timer !== null) {
			environment.clearTimeout(timer);
			timer = null;
		}
	};
	const cancel = () => {
		cancelled = true;
		clearTimer();
		observer?.disconnect();
	};
	const schedule = () => {
		if (cancelled || timer !== null) return;
		timer = environment.setTimeout(() => {
			cancel();
			start();
		}, Math.min(delay, 3600) * 1000);
	};

	if (environment.IntersectionObserver) {
		observer = new environment.IntersectionObserver(
			(entries) => {
				for (const entry of entries) {
					if (entry.target !== element) continue;
					if (entry.isIntersecting) schedule();
					else clearTimer();
				}
			},
			{ threshold: 0.01 },
		);
		observer.observe(element);
	} else {
		schedule();
	}

	return cancel;
}
